<style scoped>


</style>


<template>

<div>

news msn style

</div>

</template>

<script>

export default{
    data:function(){
        return {}
    }
}

</script>


// WEBPACK FOOTER //
// src/assets/Dynamic/app/news/main.vue